import { render, staticRenderFns } from "./DialogCompartirAgenda.vue?vue&type=template&id=51ce9f9a&"
import script from "./DialogCompartirAgenda.vue?vue&type=script&lang=js&"
export * from "./DialogCompartirAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports